module.exports = __webpack_public_path__ + "img/m-banner-kfkmkuef-vi-VN.ac2f9e51.png";